export default __webpack_public_path__ + "static/media/chuseok4.eacaa873.jpg";